<template>
  <Sheet :open="isOpen" @update:open="handleOpenChange">
    <ChatSheetContent
      v-if="chatStore.selectedContact"
      :id="chatStore.selectedContact.id"
      :name="chatStore.selectedContact.name"
      :can-receive-sms="chatStore.selectedContact.canReceiveSms"
    />
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Sheet } from '@/components/ui/sheet';
import ChatSheetContent from './ChatSheetContent.vue';
import { useMultiChatStore } from '@/components/shared/MultiChat/useMultiChatStore';

const chatStore = useMultiChatStore();

const isOpen = computed(() => chatStore.selectedContact !== null);

const handleOpenChange = (open: boolean) => {
  if (!open) chatStore.closeChat();
};
</script>
